export const users = {
    route: 'Benutzerverwaltung',
    routeTitle: 'Benutzerverwaltung',
    listOfUsers: 'Liste der Benutzer',
    addUser: 'Benutzer hinzufügen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    deleteUserButton: 'Löschen',
    deleteUserConfirmTitle: 'Sind sie sicher, dass sie diesen Eintrag löschen wollen?',
    deleteUserConfirmDescription: ['Benutzer', 'wird gelöscht.'],
    firstNameLabel: 'Vornamee',
    lastNameLabel: 'Nachname',
    loginLabel: 'Login',
    passwordLabel: 'Passwort',
    permissionsLabel: 'Berechtigungen',
    permissionsIsAdminTag: 'Administrator',
    permissionsIsTesterTag: 'Tester',
    permissionsIsNotAdminTag: 'benutzer',
    oldPasswordLabel: 'Altes Passwort',
    newPasswordLabel: 'Neues Passwort',
    confirmNewPasswordLabel: 'Neues Passwort wiederholen',
    confirmPasswordLabel: 'Passwort bestätigung',
    confirmPasswordNotCorrect: 'Hmm, die Passwörter sind nicht gleich, bitte korrigieren sie das?',
    addUserAsAdmin: 'Benutzer zum Administrator machen',
    addUserAsTester: 'Benutzer zum Tester machen',
    addUserAsInstaller: 'Benutzer zum Installer machen',
    changeUserPassword: 'Benutzer Passwort ändern'
};
